module.exports = __webpack_public_path__ + "static/media/fg-right-desk.f3c8920e.svg";